import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import UserComponent from './User/User.container';
import { Link } from './RouterCompatibility';
import Timezone from './Timezone';
import storage from '../higherOrder/storage';
import UserStore from '../stores/UserStore';
import SessionActions from '../actions/SessionActions';
import runtimeConfig from '../config/runtimeConfig';
import closeReactWidgets from '../utils/closeReactWidgets';
import { useTemplateConfig } from '../context/TemplateConfigContext';

const Header = ({ isOpen = false, setStorage = () => {}, ...props }) => {
    const { assets } = useTemplateConfig();
    const [isOpenSidebar, setIsOpenSidebar] = useState(isOpen);
    const [impersonating, setImpersonating] = useState(UserStore.getImpersonating());

    useEffect(() => {
        if (isOpen !== isOpenSidebar) {
            setIsOpenSidebar(isOpen);
        }
    }, [isOpen]);

    const toggleSidebarLayout = useCallback(() => {
        const pageWrapper = document.getElementById('page-wrapper');
        const contentSection = pageWrapper?.querySelector('.wrapper-content');
        const headSection = pageWrapper?.querySelector('.page-heading');
        const notificationSection = pageWrapper?.querySelector('.notification');
        const chartSection = pageWrapper?.querySelector('.chart_container');
        const bodySection = document.body;
        const burger = pageWrapper?.querySelector('.top-header__menu-toggle');

        if (!burger) {
            return;
        }

        setStorage({
            isOpen: !isOpenSidebar
        });

        if (burger.classList.contains('active')) {
            const overlayEl = document.querySelector('.bm-overlay');
            if (overlayEl) {
                overlayEl.click();
            }
        } else {
            if(bodySection) {
                bodySection.classList.add('open-sidebar');
            }
            if(contentSection) {
                contentSection.classList.add('active-sidebar');
            }
            if(headSection) {
                headSection.classList.add('active-sidebar');
            }
            if(notificationSection) {
                notificationSection.classList.add('active-sidebar');
            }
            if(chartSection) {
                chartSection.classList.add('active-sidebar');
            }
            if(burger) {
                burger.classList.add('active');
            }

            const trigger = document.getElementById('react-burger-menu-btn');
            if (trigger) {
                trigger.click();
            }

            const overlayEl = document.querySelector('.bm-overlay');
            overlayEl && overlayEl.addEventListener('click', function (event) {
                document.querySelector('.bm-overlay').classList.add('init');
                if(bodySection) {
                    bodySection.classList.remove('open-sidebar');
                }
                if(contentSection) {
                    contentSection.classList.remove('active-sidebar');
                }
                if(headSection) {
                    headSection.classList.remove('active-sidebar');
                }
                if(notificationSection) {
                    notificationSection.classList.remove('active-sidebar');
                }
                if(chartSection) {
                    chartSection.classList.remove('active-sidebar');
                }
                if(burger) {
                    burger.classList.remove('active');
                }
            }, { once: true });
        }
    }, [isOpenSidebar, setStorage]);

    const onClickToggle = (event) => {
        event.preventDefault();

        const closedWidgets = closeReactWidgets();
        if (closedWidgets) {
            setTimeout(() => {
                toggleSidebarLayout();
            }, 0);
        } else {
            toggleSidebarLayout();
        }
    };

    const getLogoPath = () => {
        return runtimeConfig.defaultRoute || '/';
    };

    const isExternalUrl = (url) => {
        return url && (url.startsWith('http://') || url.startsWith('https://'));
    };

    const handleLogoClick = (e) => {
        onCloseMenu();
        const path = getLogoPath();
        if (isExternalUrl(path)) {
            e.preventDefault();
            window.location.href = path;
        }
    };

    const onCloseMenu = (e) => {
        let activeHamburger = document.querySelector('.top-header__menu-toggle.active');
        if (null !== activeHamburger) {
            document.querySelector('.top-header__menu-toggle.active').click();
        }
    };

    return (
        <header className="top-header">
            <div className="logo-block">
                <button
                    className={`top-header__menu-toggle`}
                    onClick={onClickToggle}
                >
                    <span/>
                </button>
                <Link
                    to={getLogoPath()}
                    data-link={true}
                    onClick={handleLogoClick}
                >
                    <img className="logo" src={assets.brand.logoExtended} alt=""/>
                </Link>
            </div>
            <div className="top-header__left"></div>
            <div className="top-header__right">
                <UserComponent/>
            </div>
        </header>
    );
};

Header.propTypes = {
    isOpen: PropTypes.bool,
    setStorage: PropTypes.func
};

export default storage(Header, 'sidebar');
